module.exports = __webpack_public_path__ + "static/media/clubs.9491b0d9.svg";